<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 p-0">
          <card class="pb-5">
            <template slot="header">
                <h4 class="card-title cd-breadcrumb-title">
                  <i class="icon-svg icon-clipboard-list"></i>
                  <router-link to="/admin/solicitud_doc" class="cd-breadcrumb-title__link">{{$t('solicitud_documentos')}}</router-link>
                  <span class="cd-breadcrumb-title__sep">/</span>
                  <span class="cd-breadcrumb-title__current">{{ id ? $t('Editar plantilla de solicitud') : $t('Nueva plantilla de solicitud') }}</span>
                </h4>
            </template>

            <form>
              <div class="row">
                <div class="col-md-6">
                  <base-input type="text" :label="$t('nombre_plantilla')" :placeholder="$t('nombre_plantilla')" autocomplete="false" v-model="name">
                      <template v-slot:textError v-if="$v.name.$error && !$v.name.required">
                            {{$t("Campo_requerido")}}
                      </template>
                  </base-input>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div class="cd-item-adder">
                    <div class="cd-item-adder__input">
                      <base-input type="text" :label="$t('documento_a_solicitar')" :placeholder="$t('documento_a_solicitar')" autocomplete="false" v-model="item_request" @keyup.enter="onAddRequest"/>
                    </div>
                    <div class="cd-item-adder__toggle-col">
                      <span class="cd-item-adder__toggle-label" aria-hidden="true">&nbsp;</span>
                      <base-checkbox v-model="isIndex" class="cd-item-adder__toggle" field>{{$t('Grupo')}}</base-checkbox>
                    </div>
                    <button type="button" class="btn btn-add-outline cd-item-adder__submit" @click="onAddRequest">
                      <i class="icon-svg icon-plus"></i>{{$t("add")}}
                    </button>
                  </div>

                  <h6 class="cd-section-title">{{$t('documentos_solicitados')}}</h6>

                  <p class="cd-form-hint cd-template__empty" v-if="!request_items.length">{{$t('sin_elementos_solicitud')}}</p>

                  <draggable v-else
                    :list="request_items"
                    :disabled="!enabled"
                    class="cd-item-list"
                    ghost-class="cd-item--ghost"
                    handle=".cd-item__handle"
                    @start="dragging = true"
                    @end="dragging = false"
                  >
                    <div class="cd-item" :class="{ 'cd-item--group': element.isIndex }" v-for="(element,index) in request_items" :key="index">
                      <i class="icon-svg icon-grip-vertical cd-item__handle"></i>
                      <span class="cd-item__name">{{ element.name }}</span>
                      <button type="button" class="btn btn-delete-outline cd-item__delete" v-tooltip="$t('Eliminar')" @click="deleteEvent(element,index)">
                        <i class="icon-svg icon-trash"></i>
                      </button>
                    </div>
                  </draggable>
                </div>
              </div>

              <div class="d-flex justify-content-start mt-2">
                  <button type="button" class="btn cd-btn-save" @click="submit">
                      {{$t("Guardar")}}
                  </button>
              </div>
            </form>
        </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { apiCallSingle } from '../../mixins';
import { required} from 'vuelidate/lib/validators';
  import draggable from 'vuedraggable'

  export default {
    mixins: [apiCallSingle],
    data () {
      return {
        endpoint  : "template_request_documentation",
        section   : "admin/solicitud_doc",
        name    : null,
        request_items : [],
        item_request : null,
        columnsRequest  : ["name","delete_event"],
        enabled: true,
        isIndex : false,
        dragging: false
      }
    },
     components: {
          draggable,
      },
    props : {
        id : String
    },
    validations(){
        return {
            name : {
                required
            }
        }
    },
    methods : {


      loadData(){
            this.name   = this.data.name;
            this.request_items = this.data.items;

      },
      getProperties(){
            return {
              name  : this.name,
              request_template : this.request_items
          }
      },
      deleteEvent(item,index){
        this.request_items.splice(index,1);
      },
      onAddRequest(){
        if(this.item_request){
          this.request_items.push({
            name : this.item_request,
            isIndex : this.isIndex
          });
          this.item_request = null;
          this.isIndex = false;
        }
      }

    }
}
</script>

<style>
/* Plantillas de solicitud: formulario de creación/edición. Reconstruido
   con el mismo lenguaje visual que el resto de la app (cd-form-label vía
   base-input, cd-checkbox, btn-add/delete-outline, badges en píldora) en
   vez del bootstrap suelto que traía antes (hr + text-info como separador
   de sección, aspa roja de fas como icono de eliminar, botón "Guardar"
   negro...). */

/* Fila para añadir un elemento nuevo: campo + toggle "Grupo" + botón,
   alineados por su línea base en vez del grid de columnas desigual (1/9/2)
   que había antes. */
.cd-item-adder {
  display: flex;
  align-items: flex-end;
  gap: 20px;
  flex-wrap: wrap;
}
.cd-item-adder__input {
  flex: 1 1 260px;
  min-width: 200px;
  /* base-input's own .form-group trae margin-bottom:1rem (Bootstrap); sin
     anularlo aquí, ese margen cuenta como parte de la caja de este elemento
     flex y "align-items:flex-end" alinea por debajo de él, no por el borde
     real del input, dejando el checkbox y el botón de al lado colgando por
     debajo de la caja visible. */
}
.cd-item-adder__input .form-group {
  /* !important: ".form-group{margin-bottom:.5rem!important}" (utilidad
     general) le gana a cualquier regla sin !important, sea cual sea su
     especificidad. */
  margin-bottom: 0 !important;
}
/* Este campo nunca muestra error/ayuda (no se le pasa ningún v-slot para
   eso), pero base-input igualmente renderiza los divs vacíos de
   .invalid-feedback/.textInfo tras el input, y su margin-top (aunque estén
   a 0 de alto) seguía añadiendo ~8px por debajo del input real — eso era
   lo que hacía que "Grupo" y "+ Añadir" quedasen más abajo que el campo de
   texto, pese al resto de ajustes. */
.cd-item-adder__input .invalid-feedback,
.cd-item-adder__input .textInfo {
  display: none !important;
}
/* El checkbox "Grupo" no lleva ninguna etiqueta encima, a diferencia del
   campo de texto de al lado (que sí, y por eso su caja de control queda más
   abajo que la del checkbox). Se le añade un espaciador invisible con
   exactamente el mismo alto que esa etiqueta (mismo font-size/line-height/
   margin-bottom que .cd-form-label) y se fuerza la fila del propio checkbox
   a la misma altura que el input (38px, alto por defecto de .form-control),
   centrando el check dentro con flex — así ambas cajas de control quedan a
   la misma altura en vez de que el checkbox cuelgue por debajo.  */
.cd-item-adder__toggle-col {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.cd-item-adder__toggle-label {
  display: block;
  visibility: hidden;
  margin-bottom: 0.5rem;
  font-size: 0.72rem;
  line-height: 1;
}
.cd-item-adder__toggle {
  display: flex;
  align-items: center;
  height: 38px;
}
.cd-item-adder__submit {
  flex-shrink: 0;
  height: 38px;
  margin-bottom: 3px;
}
.cd-item-adder__submit .icon-svg {
  width: 14px;
  height: 14px;
  margin-right: 4px;
}

.cd-template__empty {
  margin: 0;
  padding: 20px;
  text-align: center;
  border: 1px dashed var(--cd-border-light, #e2e5ec);
  border-radius: 8px;
}

.cd-item-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 4px;
}
.cd-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border: 1px solid var(--cd-border-light, #e2e5ec);
  border-radius: 8px;
  background: #fff;
  transition: border-color .15s ease;
}
.cd-item:hover {
  border-color: var(--cd-brand-green-light, #6bc47d);
}
/* Los elementos "Grupo" son encabezados de sección dentro de la propia
   solicitud (p.ej. "Documentación fiscal"), así que se distinguen con un
   fondo verde muy suave, el nombre en negrita y una etiqueta que aclara
   qué son — antes solo se diferenciaban por un morado (#6674c3) sin
   relación con el resto de la paleta y sin explicación visual de qué
   significaba. */
.cd-item--group {
  background: rgba(46, 158, 79, 0.05);
}
.cd-item--group .cd-item__name {
  font-weight: 600;
}
.cd-item--ghost {
  opacity: 0.4;
}
.cd-item__handle {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
  color: #c2c6cf;
  cursor: grab;
}
.cd-item__badge {
  flex-shrink: 0;
  padding: 2px 9px;
  border-radius: 100px;
  background: rgba(46, 158, 79, 0.14);
  color: var(--cd-brand-green, #2E9E4F);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .03em;
}
.cd-item__name {
  flex: 1;
  color: #2a2f3c;
  font-size: 0.9rem;
}
.cd-item__delete {
  flex-shrink: 0;
}
</style>
